import {
  GLOBAL_SETTINGS_RESET_VALUES,
  GLOBAL_SETTINGS_TOGGLE_CONFIRM_MODAL,
  GLOBAL_SETTINGS_SET_GS_ITEM_VALUE,
  SAVE_GLOBAL_SETTINGS_SUCCESS,
  SAVE_GLOBAL_SETTINGS_FAILURE,
  GET_GLOBAL_SETTINGS_SUCCESS,
  GET_GLOBAL_SETTINGS_FAILURE,
  GET_GLOBAL_SETTINGS_TERMS_SUCCESS,
  GET_GLOBAL_SETTINGS_TERMS_FAILURE,
  GLOBAL_SETTINGS_DELETE_TERM_SUCCESS,
  GLOBAL_SETTINGS_DELETE_TERM_FAILURE,
  SAVE_GLOBAL_SETTINGS_TERMS_SUCCESS,
  SAVE_GLOBAL_SETTINGS_TERMS_FAILURE,
  GLOBAL_SETTINGS_SET_ITEM_VALUE,
  GLOBAL_SETTINGS_ADD_ITEM,
  GLOBAL_SETTINGS_REMOVE_ITEM,
  GLOBAL_SETTINGS_VALIDATE_ITEMS,
  GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS,
  GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE,
  SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS,
  SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE,
  GENERATE_SUMMARY_REQUEST,
  GENERATE_SUMMARY_SUCCESS,
  GENERATE_SUMMARY_FAILURE,
  GET_GB_TRENDS_REF_DAYS,
  SET_GB_TRENDS_REF_DAYS,
  GET_RAR_VALUES,
  SET_RAR_VALUES,
  SET_MENU
} from './actions';

import _ from 'lodash';
import createReducer from 'state/createReducer';

const initialState = {
  global_settings: {
    ship_to_address: '',
    smtp_host: '',
    smtp_port: '',
    smtp_username: '',
    smtp_password: '',
    smtp_ssl: null,
    smtp_from_address: '',
    min_initial_order_value: '',
    trends_instock_ref_period_days: '',
    emailValidationError: false
  },
  ProductSources: [],
  ParValues: [],
  errorMessage: null,
  list: [],
  validationError: false,

  INCOTerms: [],
  PaymentTerms: [],
  INCOTerms_errors: [],
  PaymentTerms_errors: [],

  new_INCOTerms: [],
  new_PaymentTerms: [],
  newCounter: 1,
  new_INCOTerms_errors: [],
  new_PaymentTerms_errors: [],

  FulfilmentHub: [],

  showConfirmModal: false,
  valuesChanged: false,

  sslOptions: [
    {
      value: 1,
      label: 'True'
    },
    {
      value: 0,
      label: 'False'
    }
  ],

  fileUrl: null,
  report: null,
  notInReport: null,
  totalInReport: 0,
  menu: 1,
  request: false,

  customsFileUrl: null,
  customsRequest: false,

  customsPreCheck: [],
  selectedPOs: [],

  containersList: [],
  freightsList: [],

  summaryFileUrl: null
};

const handlers = {
  [GLOBAL_SETTINGS_RESET_VALUES](state) {
    return {
      ...state,
      global_settings: {
        ship_to_address: '',
        smtp_host: '',
        smtp_port: '',
        smtp_username: '',
        smtp_password: '',
        smtp_ssl: null,
        smtp_from_address: '',
        min_initial_order_value: '',
        trends_instock_ref_period_days: '',
        emailValidationError: false
      },
      rarList: [],
      ProductSources: [],
      ParValues: [],
      errorMessage: null,
      list: [],
      validationError: false,

      INCOTerms: [],
      PaymentTerms: [],
      INCOTerms_errors: [],
      PaymentTerms_errors: [],

      new_INCOTerms: [],
      new_PaymentTerms: [],
      newCounter: 1,
      new_INCOTerms_errors: [],
      new_PaymentTerms_errors: [],

      FulfilmentHub: [],

      showConfirmModal: false,
      valuesChanged: false,

      sslOptions: [
        {
          value: 1,
          label: 'True'
        },
        {
          value: 0,
          label: 'False'
        }
      ],

      fileUrl: null,
      packingSlipsUrl: null,
      report: null,

      customsPreCheck: [],
      selectedPOs: [],

      summaryRequest: false,
      summaryFileUrl: null
    };
  },

  [SAVE_GLOBAL_SETTINGS_SUCCESS](state) {
    return {
      ...state,
      showConfirmModal: false,
      valuesChanged: false
    };
  },

  [SAVE_GLOBAL_SETTINGS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [GET_GLOBAL_SETTINGS_SUCCESS](state, payload) {
    let data = payload;
    if (data === null) {
      data = [];
    }

    const newState = _.cloneDeep(state.global_settings);

    _.each(payload, (s) => {
      if (s.name == 'smtp_ssl') {
        let sslIndex = _.findIndex(state.sslOptions, function (o) {
          return o.value == s.value;
        });
        newState[s.name] = state.sslOptions[sslIndex];
      } else {
        newState[s.name] = s.value;
      }
    });

    return {
      ...state,
      errorMessage: null,
      global_settings: newState
    };
  },

  [GET_GLOBAL_SETTINGS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [GET_GLOBAL_SETTINGS_TERMS_SUCCESS](state, payload) {
    let data = payload;
    if (data === null) {
      data = [];
    }

    let INCOTerms_errors = [];
    _.each(data.INCOTerms, (t) => {
      INCOTerms_errors.push({
        ['error-' + t.id]: false
      });
    });

    let PaymentTerms_errors = [];
    _.each(data.PaymentTerms, (t) => {
      PaymentTerms_errors.push({
        ['error-' + t.id]: false
      });
    });

    return {
      ...state,
      errorMessage: null,
      INCOTerms: _.get(data, 'INCOTerms', []),
      PaymentTerms: _.get(data, 'PaymentTerms', []),
      INCOTerms_errors: INCOTerms_errors,
      PaymentTerms_errors: PaymentTerms_errors,
      valuesChanged: false
    };
  },

  [GET_GLOBAL_SETTINGS_TERMS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [GLOBAL_SETTINGS_DELETE_TERM_SUCCESS](state) {
    return {
      ...state
    };
  },

  [GLOBAL_SETTINGS_DELETE_TERM_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [SAVE_GLOBAL_SETTINGS_TERMS_SUCCESS](state) {
    return {
      ...state,
      valuesChanged: false
    };
  },

  [SAVE_GLOBAL_SETTINGS_TERMS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [GLOBAL_SETTINGS_SET_GS_ITEM_VALUE](state, payload) {
    const newItems = _.cloneDeep(state.global_settings);

    newItems[payload.key] = payload.value;

    return {
      ...state,
      global_settings: newItems,
      valuesChanged: true
    };
  },

  [GLOBAL_SETTINGS_SET_ITEM_VALUE](state, payload) {
    const newItems = _.cloneDeep(state[payload.title]);
    const idx = _.findIndex(newItems, (o) => {
      return o.id === payload.id;
    });

    if (idx !== -1) {
      newItems[idx][payload.key] = payload.value;
    }

    return {
      ...state,
      [payload.title]: newItems,
      valuesChanged: true
    };
  },

  [GLOBAL_SETTINGS_REMOVE_ITEM](state, payload) {
    const newItems = _.cloneDeep(state[payload.key]);
    const idx = _.findIndex(newItems, (o) => {
      return o.id === payload.id;
    });

    if (idx !== -1) {
      newItems.splice(idx, 1);
    }

    return {
      ...state,
      [payload.key]: newItems
    };
  },

  [GLOBAL_SETTINGS_ADD_ITEM](state, payload) {
    const newItems = _.cloneDeep(state[payload]);

    newItems.push({
      id: 'new-' + state.newCounter,
      code: ''
    });

    const newItemErrors = _.cloneDeep(state[payload + '_errors']);

    newItemErrors['error-' + 'new-' + state.newCounter] = false;

    return {
      ...state,
      [payload]: newItems,
      [newItemErrors]: newItemErrors,
      newCounter: state.newCounter + 1,
      valuesChanged: true
    };
  },

  [GLOBAL_SETTINGS_VALIDATE_ITEMS](state) {
    let errors = false;
    const items = _.cloneDeep(state);

    let PaymentTerms_errors = [];
    _.each(items.PaymentTerms, (t) => {
      PaymentTerms_errors['error-' + t.id] = false;
      if (t.code.trim() == '') {
        PaymentTerms_errors['error-' + t.id] = true;
        errors = true;
      }
    });

    let INCOTerms_errors = [];
    _.each(items.INCOTerms, (t) => {
      INCOTerms_errors['error-' + t.id] = false;
      if (t.code.trim() == '') {
        INCOTerms_errors['error-' + t.id] = true;
        errors = true;
      }
    });

    let new_PaymentTerms_errors = [];
    _.each(items.new_PaymentTerms, (t) => {
      new_PaymentTerms_errors['error-' + t.id] = false;
      if (t.code.trim() == '') {
        new_PaymentTerms_errors['error-' + t.id] = true;
        errors = true;
      }
    });

    let new_INCOTerms_errors = [];
    _.each(items.new_INCOTerms, (t) => {
      new_INCOTerms_errors['error-' + t.id] = false;
      if (t.code.trim() == '') {
        new_INCOTerms_errors['error-' + t.id] = true;
        errors = true;
      }
    });

    return {
      ...state,
      PaymentTerms_errors: PaymentTerms_errors,
      INCOTerms_errors: INCOTerms_errors,
      new_PaymentTerms_errors: new_PaymentTerms_errors,
      new_INCOTerms_errors: new_INCOTerms_errors,
      validationError: errors
    };
  },

  [GLOBAL_SETTINGS_TOGGLE_CONFIRM_MODAL](state, payload) {
    return {
      ...state,
      showConfirmModal: payload
    };
  },

  [GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS](state, payload) {
    let data = payload;
    if (data === null) {
      data = [];
    }

    return {
      ...state,
      errorMessage: null,
      ProductSources: _.get(data, 'Sources', []),
      valuesChanged: false
    };
  },

  [GET_GLOBAL_SETTINGS_TERMS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    };
  },

  [SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS](state) {
    return {
      ...state,
      valuesChanged: false
    };
  },

  [SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE](state, payload) {
    return {
      ...state,
      fileUrl: null,
      packingSlipsUrl: null,
      report: null,
      notInReport: null,
      totalInReport: 0,
      errorMessage: payload.errorMessage
    };
  },

  [GET_GB_TRENDS_REF_DAYS](state, payload) {
    return {
      ...state,
      trends_instock_ref_period_days: payload[0].value
    };
  },

  [GENERATE_SUMMARY_REQUEST](state, payload) {
    return {
      ...state,
      summaryFileUrl: null,
      summaryRequest: true
    };
  },

  [GENERATE_SUMMARY_SUCCESS](state, payload) {
    const url = window.URL.createObjectURL(new Blob([payload.data], { type: 'application/pdf' }));

    return {
      ...state,
      summaryFileUrl: url,
      summaryRequest: false
    };
  },

  [GENERATE_SUMMARY_FAILURE](state) {
    return {
      ...state
    };
  },

  [SET_GB_TRENDS_REF_DAYS](state, payload) {
    return {
      ...state,
      trends_instock_ref_period_days: payload.value
    };
  },

  [SET_RAR_VALUES](state, payload) {
    const arr = state.rarList.map((p) => (p.id === payload.id ? { ...p, values: payload.value } : p));
    return {
      ...state,
      rarList: arr
    };
  },

  [GET_RAR_VALUES](state, payload) {
    let data = payload;
    return {
      ...state,
      rarList: data
    };
  },
  [SET_MENU](state, payload) {
    let data = payload;
    return {
      ...state,
      menu: data
    };
  }
};

export default (state = initialState, action) => createReducer(state, action, handlers);
